import * as React from "react";
import HomePageFilterComponent from "../../../components/HomePageFilterComponent";
import BaseFilter from "../../../core/models/BaseFilter";
import { useHubx } from "../../../HubX";
import {
  EVENT_HOMEPAGE_CHANGE_FILTER,
  EVENT_HOMEPAGE_OPEN_ALL,
  EVENT_HOMEPAGE_CLOSE_ALL,
  EVENT_HOME_PAGE_PRODUCT_FILTER_RECEIVE,
  EVENT_HOME_PAGE_PRODUCT_FILTER_CHANGE,
  EVENT_HOME_PAGE_SEARCH_CLICKED,
  EVENT_HOME_PAGE_STATUS_FILTER_CHANGE,
  EVENT_HOME_PAGE_SMART_FILTER_CHANGE,
  EVENT_HOME_PAGE_TABLE_COLUMNS_SELECTION_CHANGE,
} from "../../../Events";
import { HomePageViewType } from "..";
import { useHubXValue } from "../../../core/hooks/useHubHooks";
import { INSTALLATION_LEVEL_STATUS_TYPES } from "../../../core/models/LevelStatus";
import {
  BUSINESS_EVENT_STATUS_TYPES,
  BUSINESS_EVENT_STATUS_MAP,
} from "../../../core/models/EventStatus";
import { getLevelColor, getLevelStatusString } from "../../../helpers/installationTankHelpers";
import { HomeTableColumns, HomeTableColumnsType } from "../../../components/HomeTable";
import { Workflow } from "../../../core/models/Enum/Workflow";
import useConstructor from "../../../core/hooks/useConstructor";
import {
  FETCH_ALL_CLIENTS,
  FETCH_ALL_CLIENTS_BY_FILTER,
  FETCH_DISTINCT_DIRECTORIES,
  FETCH_DISTINCT_REGIONS,
} from "../../../Fedx";
import includes from "lodash/includes";
import sortBy from "lodash/sortBy";
import IFilter from "../../../core/contracts/IFilter";
import { DEFAULT_MAX_ITEM_PER_PAGE } from "../../../core/constants/appGlobals";
import { SessionCache } from "../../../helpers/cache";

function HomePageFilter() {
  const hub = useHubx();
  const cache = new SessionCache();
  const [clientOptions, setClientOptions] = React.useState<string[]>([]);
  const [client, setClient] = React.useState<string>("Todos");
  const [isOpen, setIsOpen] = React.useState<string>("all");
  const [status, setStatus] = React.useState<string>("all");
  const [directory, setDirectory] = React.useState<string>("all");
  const [directoriesOptions, setDirectoriesOptions] = React.useState<string[]>([]);
  const [eventType, setEventType] = React.useState<string>("all");
  const [textField, setTextField] = React.useState<string>("");
  const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);
  const [selectedColumns, setSelectedColumns] = React.useState<HomeTableColumnsType[]>([
    ...HomeTableColumns,
  ]);
  const [regionsOptions, setRegionsOptions] = React.useState<string[]>([]);
  const [region, setRegion] = React.useState<string>("all");



  const fetchDirectories = async () => {
    const response = await hub.request(FETCH_DISTINCT_DIRECTORIES);
    setDirectoriesOptions(response ?? []);
  };

  const fetchRegion = async () => {
    const response = await hub.request(FETCH_DISTINCT_REGIONS);
    setRegionsOptions(response ?? []);
  };

  useConstructor(() => {
    const handleCustomers = async () => {
      const clientOptions = await hub.request(FETCH_ALL_CLIENTS);
      setClientOptions(clientOptions);
      const clientFilter = cache.get<string>("filter.client") || client;
      const statusFilter = cache.get<string>("filter.status") || status;
      const isOpenFilter = cache.get<string>("filter.isopen") || isOpen;
      const typeFilter = cache.get<string>("filter.type") || eventType;
      const directoryFilter = cache.get<string>("filter.directory") || directory;
      const regionFilter = cache.get<string>("filter.region") || region;
      setClient(clientFilter);
      setIsOpen(isOpenFilter);
      setStatus(statusFilter);
      setEventType(typeFilter);
      setDirectory(directoryFilter);
      setRegion(regionFilter);

    };
    handleCustomers();
    fetchRegion();
  });

  const openClosedValues = ["Aberto", "Fechado", "Isento"];
  const eventTypes = [6, 7, 8, 9];

  const [mobileDialogFiltersOpen, setMobileDialogFiltersOpen] = React.useState<boolean>(false);

  const handleSearchClick = () => {
    cache.set("filter.type", eventType);
    cache.set("filter.client", client);
    cache.set("filter.isopen", isOpen);
    cache.set("filter.status", status);
    cache.set("filter.directory", directory);
    cache.set("filter.region", region);
    const filterObject: IFilter = {
      pageSize: DEFAULT_MAX_ITEM_PER_PAGE,
      pageNumber: 1,
      orderByAscending: false,
      data: {
        id: textField,
        client: client !== "Todos" ? client : "",
        isOpen: isOpen === "all" ? "" : isOpen === "Aberto" ? 0 : isOpen === "Fechado" ? 1 : 2,
        status: status !== "all" ? status : "",
        eventType: eventType !== "all" ? eventType : "",
        // directory: directory !== "all" ? directory : "",
        region: region !== "all" ? region : "",

      },
    };
    hub.notify(EVENT_HOME_PAGE_SEARCH_CLICKED, filterObject);
  };

  const handleClear = () => {
    cache.delete("filter.client");
    cache.delete("filter.status");
    cache.delete("filter.type");
    cache.delete("filter.isopen");
    cache.delete("filter.directory");
    cache.delete("filter.region");


    setTextField("");
    setClient("Todos");
    setIsOpen("all");
    setStatus("all");
    setEventType("all");
    setDirectory("all");
    setRegion("all");

  };

  const filterCustomCustomers = async (filter: string) => {
    const clientOptions = await hub.request(FETCH_ALL_CLIENTS_BY_FILTER, filter);
    setClientOptions(clientOptions);
  };

  const handleChangeType = React.useCallback((e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;
    setEventType(newValue);
  }, []);

  const handleChangeClient = React.useCallback(
    (e: React.ChangeEvent<{ value: string; textContent: string }>) => {
      const newValue = e?.target?.textContent;
      if (newValue) {
        setClient(newValue);
      }
    },
    []
  );

  const handleChangeActiveness = React.useCallback((e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;
    setIsOpen(newValue);
  }, []);

  const handleChangeStatus = React.useCallback((e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;
    setStatus(newValue);
  }, []);

  const handleChangeDirectory = React.useCallback((e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;
    setDirectory(newValue);
  }, []);

  const handleChangeRegion = React.useCallback((e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;
    setRegion(newValue);
  }, []);

  const filters: BaseFilter[] = React.useMemo(
    () => [
      {
        id: "client",
        items: [
          ...sortBy(
            clientOptions.map((x) => {
              return {
                key: x,
                value: x,
              };
            }),
            "key"
          ),
        ],
        label: "Cliente",
        value: client,
        handleChange: handleChangeClient,
        requestItems: filterCustomCustomers,
        noOptionsText: "Nenhum cliente ou evento associado"
      },
      {
        id: "status",
        items: [
          { key: "all", value: <strong>Todos</strong> },
          ...BUSINESS_EVENT_STATUS_TYPES.map((x) => {
            return {
              key: x,
              value: BUSINESS_EVENT_STATUS_MAP[x],
            };
          }),
        ],
        label: "Último Status",
        value: status,
        handleChange: handleChangeStatus,
      },
      {
        id: "isOpen",
        items: [
          { key: "all", value: <strong>Todos</strong> },
          ...sortBy(
            openClosedValues.map((x, idx) => {
              return { key: x, value: x };
            }),
            "key"
          ),
        ],
        label: "Situação",
        value: isOpen,
        handleChange: handleChangeActiveness,
      },
      {
        id: "eventType",
        items: [
          { key: "all", value: <strong>Todos</strong> },
          ...sortBy(
            eventTypes.map((x) => {
              return { key: x, value: Workflow[x] };
            }),
            "key"
          ),
        ],
        label: "Tipo",
        value: eventType,
        handleChange: handleChangeType,
      },
      {
        id: "region",
        items: [
          { key: "all", value: <strong>Todos</strong> },
          ...sortBy(
            regionsOptions?.map((x) => {
              return { key: x, value: x };
            }),
            "key"
          ),
        ],
        label: "Região",
        value: region,
        handleChange: handleChangeRegion,
      },
    ],
    [
      clientOptions,
      client,
      handleChangeClient,
      status,
      handleChangeStatus,
      openClosedValues,
      isOpen,
      handleChangeActiveness,
      eventTypes,
      eventType,
      handleChangeType,
      directoriesOptions,
      handleChangeDirectory,
      handleChangeRegion,

    ]
  );

  const handleChangeTextField = (e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;
    setTextField(newValue);
  };

  const handleClickColumnOption = (column: HomeTableColumnsType) => {
    let newValue;
    if (includes(selectedColumns, column)) {
      newValue = selectedColumns.filter((x) => x !== column);
      setSelectedColumns(newValue);
    } else {
      newValue = [...selectedColumns, column];
      setSelectedColumns((prev) => [...prev, column]);
    }

    hub.notify(EVENT_HOME_PAGE_TABLE_COLUMNS_SELECTION_CHANGE, newValue);
  };

  return (
    <HomePageFilterComponent
      handleChangeSearch={handleChangeTextField}
      handleSearchClick={handleSearchClick}
      handleClear={handleClear}
      textFieldValue={textField}
      filters={filters}
      tableDialogOpen={dialogOpen}
      handleCloseDialog={() => setDialogOpen(false)}
      handleOpenDialog={() => setDialogOpen(true)}
      columnsSelected={selectedColumns}
      onClickColumnOption={handleClickColumnOption}
      mobileDialogOpen={mobileDialogFiltersOpen}
      handleOpenMobileDialog={() => setMobileDialogFiltersOpen(true)}
      handleCloseMobileDialog={() => {
        setMobileDialogFiltersOpen(false);
      }}
    />
  );
}

export default HomePageFilter;
